var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"center"},[(_vm.customer.tickets_active.length > 0)?_c('transfer-badge',{attrs:{"transfer":_vm.customer.tickets_active,"question_page":'true'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }